module.exports = __webpack_public_path__ + "static/media/didi.82f1b9de.png";